import { render, staticRenderFns } from "./promotion-card.component.vue?vue&type=template&id=221bf687&scoped=true"
import script from "./promotion-card.component.vue?vue&type=script&lang=ts"
export * from "./promotion-card.component.vue?vue&type=script&lang=ts"
import style0 from "./promotion-card.component.vue?vue&type=style&index=0&id=221bf687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bf687",
  null
  
)

export default component.exports